import React, { Component } from 'react';
import { Link } from "react-router-dom";

//i18n
import { withTranslation } from "react-i18next";

class Breadcrumbs extends Component {
    render() {

        const itemsLength = this.props.breadcrumbItems.length;

        return (
            <React.Fragment>
                <div>
                    <div className='col-md-12'>
                        <div className="page-title-box d-flex align-items-center justify-content-between">
                            <h4 className="mb-0">{this.props.t(this.props.title)}</h4>

                            <div className="page-title-right">
                                <div className='mb-0'>
                                    {
                                        this.props.breadcrumbItems.map((item, key) =>
                                            key + 1 === itemsLength ?
                                                <div key={key} active>{this.props.t(item.title)}</div>
                                                : <div key={key} ><Link to={item.link}>{this.props.t(item.title)}</Link></div>
                                        )
                                    }
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

export default withTranslation()(Breadcrumbs);